import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createSlots as _createSlots, createVNode as _createVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-29f680ed"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"grid-column":"1/-1"} }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title_with_line" }, "设置签署方式", -1))

import {
  CONTRACT_TYPE,
  ContractMenuType,
  ContractType,
  TRADE_STRUCTURE
} from './../constants/index';
import {
  computed,
  ref,
  withDefaults,
  toRefs,
  watch,
  nextTick
} from 'vue';
import {
  BaseForm,
  BaseInput,
  BaseSelect,
  BaseFormItem,
  BaseTable,
  BaseUpload,
  XrkMessage,
  useTableColumn
} from 'xrk-components';
import { BaseDatepickerLongterm } from '@/components/base/base-datepicker-longterm/index';
import { uploadApi } from '@data-source/common/apis';
import { getEnterpriseList, getPartOptList } from './../data-source/apis';
import { uniqueId } from 'lodash';
import { preview } from '@/utils/file';


export default /*#__PURE__*/_defineComponent({
  __name: 'contract-detail',
  props: {
    margeColumn: { default: () => [] },
    disabled: { type: Boolean, default: () => true },
    contractType: {},
    tableColMid: { type: Function, default: () => [] },
    detail: {},
    disabledItems: {},
    prefix: { default: '' },
    pageType: {}
  },
  setup(__props: any, { expose: __expose }) {

const props = __props;

const { disabled, contractType, tableColMid, detail, disabledItems } =
  toRefs(props);

/** 甲方 */
const participantsPartyAOpt = ref([]);
/** 乙方 */
const participantsPartyBOpt = ref([]);

const uploadRef = ref();
const formRef = ref();
const margeCols = computed(() => [...props.margeColumn, 'taxPattern']);

const getPartiName = index => `participant${+index === 0 ? 'A' : 'B'}`;
const getSignName = index => `${+index === 0 ? 'first' : 'second'}PartyId`;

const rules = {
  contractTemplateName: [
    {
      required: true,
      message: `${props.prefix}名称不能为空`,
      trigger: 'blur'
    }
  ],
  contractType: [
    {
      required: true,
      message: `${props.prefix}类型不能为空`,
      trigger: 'change'
    }
  ],
  contractTemplateUrl: [
    {
      required: true,
      validator: (_rule: any, value: any, callback: any) => {
        if (!value?.length) {
          callback(new Error('请上传签署文件'));
        } else {
          callback();
        }
      },
      trigger: 'change'
    }
  ],
  validity: [
    {
      required: true,
      validator: (_rule: any, value: any, callback: any) => {
        if (!value?.length) {
          callback(new Error('合同有效期不能为空'));
        } else {
          callback();
        }
      },
      trigger: 'change'
    }
  ]
};

/** 获取甲方对应的乙方列表 */
const findPartList = index => {
  const { participantB, participantA } = formData.value;
  // 甲方选项
  if (index === 0) {
    if (!participantB) {
      return participantsPartyAOpt.value || [];
    }
    return (
      participantsPartyBOpt.value.find(item => item.id === participantB)
        ?.children || []
    );
  }
  // 乙方选项
  if (!participantA) {
    return participantsPartyBOpt.value || [];
  }
  return (
    participantsPartyAOpt.value.find(item => item.id === participantA)
      ?.children || []
  );
};
const formData = ref<any>({
  contractType: contractType.value,
  validity: [],
  contractTemplateUrl: [],
  contractTemplateName: '',
  taxPattern: ''
});

const columns = computed(() => [
  useTableColumn({
    label: '参与方',
    prop: 'party',
    render: ({ index }) => (
      <BaseFormItem
        prop={getPartiName(index)}
        rules={[
          {
            required: true,
            message: '请选择参与方',
            trigger: 'change'
          }
        ]}
      >
        {index === 0 ? '甲方' : '乙方'}
        <BaseSelect
          clearable
          style="width:calc(100% - 36px);margin-left: 8px"
          placeholder="请选择"
          filterable={false}
          options={findPartList(index)}
          key={uniqueId()}
          init={true}
          labelKey="name"
          valueKey="id"
          v-model={formData.value[getPartiName(index)]}
          disabled={
            disabled.value ||
            disabledItems.value.includes('party') ||
            (index === 0
              ? participantsPartyAOpt.value?.length === 1
              : participantsPartyBOpt.value?.length === 1)
          }
          onChange={val => {
            // 如果另一方列表中没有该选项，则清空选项
            if (
              val &&
              !findPartList(index === 0 ? 1 : 0).some(
                item =>
                  item.id ===
                  formData.value[`participant${+index === 0 ? 'B' : 'A'}`]
              )
            ) {
              formData.value[`participant${+index === 0 ? 'B' : 'A'}`] = '';
            }
            formData.value[getSignName(index)] = '';
            formRef.value.validateField(getPartiName(index));
          }}
        ></BaseSelect>
      </BaseFormItem>
    )
  }),
  useTableColumn({
    label: '签署方',
    prop: 'signedParty',
    render: ({ index }) => (
      <BaseFormItem
        prop={getSignName(index)}
        rules={[
          {
            required: true,
            message: '请选择签署方',
            trigger: 'change'
          }
        ]}
      >
        <BaseSelect
          clearable
          placeholder={`请选择${index === 0 ? '甲方' : '乙方'}`}
          filterUseRemote={true}
          init={true}
          filter={true}
          labelKey="name"
          valueKey="id"
          remoteMethod={async _ => {
            const party = formData.value[getPartiName(index)];
            if (!party) {
              return {
                data: {
                  list: []
                }
              };
            }
            const res = await getEnterpriseList({
              type: props.pageType,
              entpId: detail.value[getSignName(index)],
              entpName:
                detail.value[`${+index === 0 ? 'first' : 'second'}PartyName`],
              participantValue: party,
              contractType: formData.value.contractType,
              source: 2
            });

            return res;
          }}
          v-model={formData.value[getSignName(index)]}
          disabled={
            disabled.value || disabledItems.value.includes('signedParty')
          }
          onVisibleChange={visible => {
            const party = formData.value[getPartiName(index)];
            if (visible && !party) {
              XrkMessage.error('请先选择参与方');
            }
          }}
          onChange={() => {
            formRef.value.validateField(getSignName(index));
          }}
        ></BaseSelect>
      </BaseFormItem>
    )
  }),
  ...tableColMid.value(formData),
  useTableColumn({
    label: '适用交易结构',
    prop: 'taxPattern',
    render: () => (
      <BaseFormItem
        prop={['taxPattern']}
        rules={[
          {
            required: true,
            message: '请选择交易结构',
            trigger: 'change'
          }
        ]}
      >
        <BaseSelect
          clearable
          placeholder="请选择交易结构"
          v-model={formData.value.taxPattern}
          disabled={
            disabled.value || disabledItems.value.includes('taxPattern')
          }
          options={TRADE_STRUCTURE}
        ></BaseSelect>
      </BaseFormItem>
    )
  })
]);

const disabledDate = time => {
  if (props.pageType === ContractMenuType.MANAGEMENT) {
    return;
  }
  return time.getTime() < new Date().getTime() - 8.64e7;
};

const getLastStr = str => {
  const match = str.match(/.*\/([^/]*)$/);
  return match ? match[1] : '';
};

watch(
  () => detail.value,
  val => {
    if (!Object.keys(val || {}).length) {
      return;
    }
    const { contractTemplateUrl, validityStart, validityEnd, urlFileName } =
      val;
    formData.value = {
      ...formData.value,
      ...val,
      contractTemplateUrl: contractTemplateUrl
        ? [
            {
              name: urlFileName || getLastStr(contractTemplateUrl),
              url: contractTemplateUrl
            }
          ]
        : [],
      validity: validityStart ? [validityStart, validityEnd] : []
    };
  },
  {
    immediate: true
  }
);

const onError = errorInfo => {
  XrkMessage.error(errorInfo.msg);
};

const httpRequest = async ({ file }) => {
  return uploadApi({ file });
};
const uploadChange = () => {
  formRef.value.validateField('contractTemplateUrl');
};

const handleContractTypeChange = val => {
  formData.value.participantA = '';
  formData.value.participantB = '';
  formData.value[getSignName(0)] = '';
  formData.value[getSignName(1)] = '';
  getParticipantOpt(val);
};

// 获取参与方选项
const getParticipantOpt = async val => {
  participantsPartyAOpt.value = await getPartOptList({
    type: val,
    typeOfPartyAAndPartyB: 1
  });
  participantsPartyBOpt.value = await getPartOptList({
    type: val,
    typeOfPartyAAndPartyB: 2
  });
  // 从查看进来的话不设置默认值
  if (disabled.value) {
    return;
  }
  await nextTick();
  // 市场服务人员合同，乙方默认，甲方不默认，其他均默认选中第一项
  if (+formData.value.contractType !== ContractType.MARKET_PERSON) {
    formData.value.participantA = participantsPartyAOpt.value[0].id;
  }
  formData.value.participantB = participantsPartyBOpt.value[0].id;
};
getParticipantOpt(contractType.value);

/**
 * 将甲乙方公用的特性合并单元格
 * @param {*} { column, rowIndex }
 * @returns
 */
const objectSpanMethod = ({ column, rowIndex }) => {
  if (margeCols.value.includes(column.property)) {
    if (rowIndex === 0) {
      return {
        rowspan: 2,
        colspan: 1
      };
    }
    return {
      rowspan: 0,
      colspan: 0
    };
  }
};

const handleValidityChange = () => {
  formRef.value.validateField('validity');
};

const handlePreview = async () => {
  const url = formData.value.contractTemplateUrl[0].url;
  preview(url);
};

__expose({
  submit: async () => {
    await formRef.value.validate();
    const {
      validity: [validityStart, validityEnd]
    } = formData.value;
    const result = {
      ...formData.value,
      validityStart,
      validityEnd,
      contractTemplateUrl: formData.value.contractTemplateUrl[0].url
    };
    delete result.validity;
    return result;
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(BaseForm), {
    ref_key: "formRef",
    ref: formRef,
    model: formData.value,
    "label-position": "top",
    rules: rules,
    "column-count": 2
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(BaseFormItem), {
        style: {"grid-column":"1/-1"},
        prop: "contractTemplateUrl"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(BaseUpload), {
            style: {"width":"calc((100% - 20px) / 2)"},
            ref_key: "uploadRef",
            ref: uploadRef,
            disabled: _unref(disabled) || _unref(disabledItems).includes('contractTemplateUrl'),
            fileList: formData.value.contractTemplateUrl,
            "onUpdate:fileList": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.contractTemplateUrl) = $event)),
            "http-request": httpRequest,
            onError: onError,
            onChange: uploadChange,
            "auto-upload": true,
            multiple: false,
            accept: ['.pdf'],
            limit: 1,
            limitSize: 100,
            drag: false,
            btnText: "添加签署文件",
            uploadBtnProps: { limitOverHide: true },
            onPreview: handlePreview
          }, _createSlots({ _: 2 }, [
            (formData.value.contractTemplateUrl?.length < 1)
              ? {
                  name: "tip",
                  fn: _withCtx(() => [
                    _createTextVNode(" 只支持 PDF 文件，单份文件小于100M ")
                  ]),
                  key: "0"
                }
              : undefined
          ]), 1032, ["disabled", "fileList"])
        ]),
        _: 1
      }),
      _createVNode(_unref(BaseFormItem), {
        label: `${_ctx.prefix}类型`,
        prop: "contractType",
        required: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(BaseSelect), {
            style: {"width":"100%"},
            placeholder: `请选择${_ctx.prefix}类型`,
            options: _unref(CONTRACT_TYPE),
            modelValue: formData.value.contractType,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.contractType) = $event)),
            disabled: _unref(disabled) || _unref(disabledItems).includes('contractType'),
            onChange: handleContractTypeChange
          }, null, 8, ["placeholder", "options", "modelValue", "disabled"])
        ]),
        _: 1
      }, 8, ["label"]),
      _createVNode(_unref(BaseFormItem), {
        label: `${_ctx.prefix}名称`,
        prop: "contractTemplateName",
        required: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(BaseInput), {
            style: {"width":"100%"},
            maxlength: "50",
            "show-word-limit": "",
            placeholder: `请输入${_ctx.prefix}名称`,
            disabled: _unref(disabled) || _unref(disabledItems).includes('contractTemplateName'),
            modelValue: formData.value.contractTemplateName,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.contractTemplateName) = $event))
          }, null, 8, ["placeholder", "disabled", "modelValue"])
        ]),
        _: 1
      }, 8, ["label"]),
      _createVNode(_unref(BaseFormItem), {
        label: "合同有效期",
        prop: "validity",
        required: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(BaseDatepickerLongterm), {
            startPlaceholder: "有效期始",
            disabled: _unref(disabled) || _unref(disabledItems).includes('validity'),
            endPlaceholder: "有效期止",
            value: formData.value.validity,
            "onUpdate:value": [
              _cache[3] || (_cache[3] = ($event: any) => ((formData.value.validity) = $event)),
              handleValidityChange
            ],
            "disabled-date": disabledDate
          }, null, 8, ["disabled", "value"])
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createVNode(_unref(BaseTable), {
          data: [{}, {}],
          columns: columns.value,
          "span-method": objectSpanMethod
        }, null, 8, ["columns"]),
        _renderSlot(_ctx.$slots, "default", { formData: formData.value })
      ])
    ]),
    _: 3
  }, 8, ["model"]))
}
}

})